"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
const react_1 = __importStar(require("react"));
const use_field_api_1 = __importDefault(require("@data-driven-forms/react-form-renderer/use-field-api"));
const use_form_api_1 = __importDefault(require("@data-driven-forms/react-form-renderer/use-form-api"));
const ExpandableSection_1 = __importDefault(require("../../../ExpandableSection"));
const Stack_1 = __importDefault(require("../../../../layouts/Stack"));
const Box_1 = __importDefault(require("../../../../layouts/Box"));
const ExpandableSectionMapping = (props) => {
    const _a = use_field_api_1.default(props), { fields, title, description, variant = 'default', input, validateOnMount, showError, meta: { submitFailed, error } } = _a, rest = __rest(_a, ["fields", "title", "description", "variant", "input", "validateOnMount", "showError", "meta"]);
    const { renderForm } = use_form_api_1.default();
    const editedFields = react_1.useMemo(() => {
        return fields.map((field) => (Object.assign(Object.assign({}, field), { showError, name: `${input.name}.${field.name}` })));
    }, [fields, input.name, showError]);
    const [expanded, setExpanded] = react_1.useState(rest.expanded || false);
    react_1.useEffect(() => {
        if (!expanded) {
            const isError = (validateOnMount || submitFailed || showError) && !!error;
            if (isError || input.value) {
                setExpanded(true);
            }
        }
    }, [validateOnMount, submitFailed, error, expanded, showError, input.value]);
    return (react_1.default.createElement(Box_1.default, { mb: 2 },
        react_1.default.createElement(ExpandableSection_1.default, { header: title, variant: variant, description: description, expanded: expanded, onChange: (open) => {
                setExpanded(open);
            } },
            react_1.default.createElement(Box_1.default, { width: "100%" },
                react_1.default.createElement(Stack_1.default, null, renderForm(editedFields))))));
};
exports.default = ExpandableSectionMapping;
//# sourceMappingURL=index.js.map